import { useState, useRef, useEffect } from 'react';
import './Topo.css'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import UserWrapper from '../../components/UserWrapper';

function Topo({ assistant, sessionId, selfAssistant = false }) {

  // AuthContext email not needed in this component
  const [selectedButton, setSelectedButton] = useState('/siteAssist');
  const [shouldShowPublishDisabledState, setShouldShowPublishDisabledState] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const navigate = useNavigate();
  const [, setShowLogout] = useState(false);
  const menuRef = useRef(null);
  const { t: tSelfAssist } = useTranslation('assistantConfiguration');
  const { t: tCommon } = useTranslation('common');
  // Variável que controla se o Database está disponível
  const isDatabaseAvailable = true; // Definido como falso para bloquear

  // Recebendo o Id do assistente a partir do Hub
  const location = useLocation();
  const assistantId = location.state?.assistantId || 'nada'; // Garante que assistantId não seja undefined
  const assistantIcon = location.state?.assistantIcon;
  const isManagement = location.pathname === '/management';
  const isMobile = useMediaQuery('(max-width: 665px)');

  useEffect(() => {
    const navRoutes = ['/siteAssist', '/report', '/database'];
    if (navRoutes.includes(location.pathname)) {
      setSelectedButton(location.pathname);
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        // Verifica se o clique foi no ícone do usuário
        const userIcon = document.querySelector('.header__user-initial');
        if (userIcon && !userIcon.contains(event.target)) {
          setShowLogout(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const handlePublishStateChange = (event) => {
      const detail = event.detail || {};
      setShouldShowPublishDisabledState(Boolean(detail.shouldShowPublishDisabledState));
      if (typeof detail.isPublished === 'boolean') {
        setIsPublished(detail.isPublished);
      }
    };

    window.addEventListener('assistantPublishStateChange', handlePublishStateChange);

    return () => {
      window.removeEventListener('assistantPublishStateChange', handlePublishStateChange);
    };
  }, []);

  const handleNavigation = (route) => {
    if (route !== '/database' || isDatabaseAvailable) {
      setSelectedButton(route);
      navigate(route, { state: { assistantId: assistantId, sessionId: sessionId } });
    }
  };

  const handleLogoClick = () => {
    navigate('/hub'); // Redireciona para a página /hub
  };


  return (
    <header className={`header ${(assistant || selfAssistant) ? 'self-assist' : ''} ${isManagement ? 'management-header' : ''}`}>

      <div className={`header-margem ${(assistant || selfAssistant) ? 'self-assist' : ''}`}>

        <div
          data-testid="header-right"
          className={`header__left ${(assistant || selfAssistant) ? 'self-assist' : ''}`}
          onClick={handleLogoClick}
        >
          <img
            src="/imagens/iris.svg"
            alt={tCommon('companyLogo')}
            className="header-icon"
          />

          {(assistant || selfAssistant) && (
            <img src="/imagens/left-arrow-return.svg" alt="" className="nav-icon" />
          )}



        </div>

        <div className={`header__center ${(assistant || selfAssistant) ? 'self-assist' : ''} ${isManagement ? 'management-header__center' : ''}`}>
          {assistant && assistant != "llm-braskem" && (
            <div className='assistant-wrapper'>
              <div className="assistant-info">
                {/* Renderiza SVG diretamente */}
                {assistantIcon != null ? (
                  <div
                    className="assistant-icon"
                    dangerouslySetInnerHTML={{ __html: assistantIcon }}
                  />
                ) : (
                  <div
                    className="assistant-icon"
                    dangerouslySetInnerHTML={{
                      __html: `<svg width="54" height="38" viewBox="0 0 54 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M38.25 25.6875C38.25 26.2438 38.0851 26.7875 37.776 27.2501C37.467 27.7126 37.0277 28.0731 36.5138 28.2859C35.9999 28.4988 35.4344 28.5545 34.8888 28.446C34.3433 28.3375 33.8421 28.0696 33.4488 27.6763C33.0554 27.2829 32.7876 26.7818 32.6791 26.2362C32.5705 25.6906 32.6262 25.1251 32.8391 24.6112C33.052 24.0973 33.4125 23.6581 33.875 23.349C34.3375 23.04 34.8813 22.875 35.4375 22.875C36.1834 22.875 36.8988 23.1713 37.4262 23.6988C37.9537 24.2262 38.25 24.9416 38.25 25.6875ZM18.5625 22.875C18.0063 22.875 17.4625 23.04 17 23.349C16.5375 23.6581 16.177 24.0973 15.9641 24.6112C15.7512 25.1251 15.6955 25.6906 15.8041 26.2362C15.9126 26.7818 16.1804 27.2829 16.5738 27.6763C16.9671 28.0696 17.4682 28.3375 18.0138 28.446C18.5594 28.5545 19.1249 28.4988 19.6388 28.2859C20.1527 28.0731 20.592 27.7126 20.901 27.2501C21.2101 26.7875 21.375 26.2438 21.375 25.6875C21.375 24.9416 21.0787 24.2262 20.5512 23.6988C20.0238 23.1713 19.3084 22.875 18.5625 22.875ZM53.25 28.5V34.125C53.25 35.1196 52.8549 36.0734 52.1517 36.7767C51.4484 37.4799 50.4946 37.875 49.5 37.875H4.50001C3.50545 37.875 2.55162 37.4799 1.84836 36.7767C1.1451 36.0734 0.750011 35.1196 0.750011 34.125V28.7649C0.746671 25.1504 1.48075 21.5732 2.90734 18.2521C4.33393 14.9311 6.42304 11.936 9.04689 9.45002L3.17345 3.57658C2.82162 3.22475 2.62397 2.74757 2.62397 2.25002C2.62397 1.75246 2.82162 1.27528 3.17345 0.923454C3.52528 0.571628 4.00245 0.373974 4.50001 0.373974C4.99757 0.373974 5.47475 0.571628 5.82657 0.923454L11.9578 7.0547C16.3602 3.93628 21.6203 2.25775 27.0152 2.24978C32.4101 2.2418 37.6752 3.90478 42.0867 7.01017L48.1805 0.916423C48.5323 0.564597 49.0095 0.366943 49.507 0.366943C50.0046 0.366943 50.4818 0.564597 50.8336 0.916423C51.1854 1.26825 51.3831 1.74543 51.3831 2.24299C51.3831 2.74054 51.1854 3.21772 50.8336 3.56955L45.0047 9.39845C45.1805 9.56486 45.3563 9.73361 45.5297 9.90705C47.9846 12.3399 49.9313 15.2364 51.2567 18.4284C52.5821 21.6203 53.2596 25.0439 53.25 28.5ZM49.5 28.5C49.5 22.5326 47.1295 16.8097 42.9099 12.5901C38.6903 8.37055 32.9674 6.00002 27 6.00002H26.9203C14.557 6.0422 4.50001 16.2539 4.50001 28.7649V34.125H49.5V28.5Z" fill="#0067FF"/>
                  </svg>` }}
                  />
                )}
                <span className="assistant-name">{`${assistant}`}</span>
              </div>
            </div>
          )}


          {/* Renderiza o navbar apenas se o assistant for o 'site-assist' */}
          {assistantId === '3' && (
            <nav className='navbar'>

              <img src="/imagens/nav_icon.svg" alt="" className="nav-icon" />
              <div className="buttongroup">
                <button
                  onClick={() => handleNavigation('/siteAssist')}
                  className={selectedButton === '/siteAssist' ? 'selected' : ''}
                >
                  {tCommon('assistant')}
                </button>
                <button
                  onClick={() => handleNavigation('/report')}
                  className={selectedButton === '/report' ? 'selected' : ''}
                >
                  {tCommon('report')}
                </button>
                <button
                  onClick={() => handleNavigation('/database')}
                  className={selectedButton === '/database' ? 'selected' : ''}
                  style={{
                    cursor: isDatabaseAvailable ? 'pointer' : 'not-allowed',
                    opacity: isDatabaseAvailable ? '1' : '0.5'
                  }}
                  disabled={!isDatabaseAvailable} // Desabilita o botão se o Database não estiver disponível
                >
                  {tCommon('database')}
                </button>
              </div>
            </nav>
          )}

          {selfAssistant && (
            <p style={{ fontSize: "16px", fontWeight: "600" }}>{tSelfAssist("assistant_creation")}</p>
          )}



        </div>

        {isMobile ? (
          <div className='mobile-wrapper'>
            <UserWrapper />
          </div>
        ) : (
          <div className={`header__right ${(assistant || selfAssistant) ? 'self-assist' : ''}`} >
            {/* For the self-assistant screen, replace the user wrapper with a "Publicar" button */}
            {selfAssistant ? (
              <button
                className={`publish-button ${isPublished ? 'unpublish-button' : ''} ${shouldShowPublishDisabledState ? 'publish-button-disabled' : ''}`}
                data-testid="publish-button"
                onClick={() => {
                  if (typeof window !== 'undefined') {
                    if (isPublished) {
                      // Evento para despublicar
                      window.dispatchEvent(new CustomEvent('assistantUnpublishAttempt', {
                        detail: { source: 'header' }
                      }));
                    } else {
                      // Evento para publicar
                      window.dispatchEvent(new CustomEvent('assistantPublishAttempt', {
                        detail: { source: 'header' }
                      }));
                    }
                  }
                }}
                disabled={shouldShowPublishDisabledState}
              >
                {isPublished ? tSelfAssist("unpublish") : tSelfAssist("publish")}
              </button>
            ) : (
              <UserWrapper />
            )}
          </div>
        )}
        

      </div>

    </header>
  )
}

export default Topo